import { Checkbox } from "@mui/material";
import { useController } from "react-hook-form";

function BTCheckBox(props: any) {
    const { field } = useController(props);
    return (
        <div>
            <Checkbox
                id={props.name}
                name={props.name}
                checked={typeof field.value === "boolean" && field.value !== undefined ? field.value : true}
                onChange={field.onChange}
                inputRef={field.ref}
            />
            {props.label}</div>
    );
}

export default BTCheckBox;
